import React from 'react';

import Cassette from './Cassette';

export default class Cassettes extends React.Component {
	renderCassettes() {
		const out = [];
		for (let i = 0; i < this.props.items.length; i++) {
			out.push((
				<Cassette
					key={`cassette-${i}`}
					active={this.props.activeCassette && this.props.items[i].id === this.props.activeCassette.ID}
					label={this.props.items[i].label}
					image={this.props.items[i].image}
					onClick={() => this.props.onSelect(this.props.items[i].id)}
				/>
			))
		}

		// out.push(<div key={`tape-cassette-${out.length + 1}`} className="gecko-tape-recorder__cassette gecko-tape-recorder__cassette-dummy" label="test" />);
		// out.push(<div key={`tape-cassette-${out.length + 2}`} className="gecko-tape-recorder__cassette gecko-tape-recorder__cassette-dummy" label="test" />);
		// out.push(<div key={`tape-cassette-${out.length + 3}`} className="gecko-tape-recorder__cassette gecko-tape-recorder__cassette-dummy" label="test" />);

		return out;
	}

	render() {
		if (!this.props.items) {
			return null;
		}

		return (
			<div className="gecko-tape-recorder__cassettes">
				<div className="gecko-tape-recorder__cassettes-nav">
					{this.props.children}
				</div>
				<div className="gecko-tape-recorder__cassettes-items">
					{this.renderCassettes()}
				</div>
			</div>
		)
	}
}